import styled from "styled-components";

const InputContainer = styled.div`
  margin-bottom: 6px;
  position: relative;
`;

export default InputContainer;
